import { EStatusType } from 'src/types/enums/EStatusType'

import { ProgressIndicator } from './ProgressIndicator'

export const ExportInProgress = (
  <ProgressIndicator status={EStatusType.inProgress}>Export in progress...</ProgressIndicator>
)
